/**
 * 系统管理  角色管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formData" class="user-search">

      <el-form-item label="搜索：">
        <el-input size="small" v-model="formData.role" placeholder="输入角色名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formData.description" placeholder="输入角色代码"></el-input>
      </el-form-item>
			<el-form-item>
				<el-cascader
					size="small"
					placeholder="请选择部门"
					v-model="formData.depId"
					ref="depsCascader"
					:options="deptData"
					:props="{ expandTrigger: 'click',children:'deps',label:'departmentName',checkStrictly: true,value:'id'}"
					@change="getDepId">
					
				 </el-cascader>
			</el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button> -->
				<prems-button  perms="sys:role:add" label="添加"  icon="el-icon-circle-plus-outline" size="small" type="primary"  @click="handleEdit" /> 
      </el-form-item>
			
			
			
    </el-form>
	
	
	<el-row style="margin-bottom: 10px;">
		<el-button size="mini" type="danger" @click="deleteUser" :disabled="!delIds.length" >删除选中</el-button>	
	</el-row>
    <!--列表-->
    <el-table size="small" :data="listData" :header-cell-style="this.$store.state.headerCss" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;"@selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column  show-overflow-tooltip  sortable prop="role" min-width="180" label="角色名称" >
      </el-table-column>
			 <el-table-column show-overflow-tooltip prop="description"  min-width="150" label="角色描述" >
			</el-table-column>
			<el-table-column  label="所属部门" width="240">
				<template slot-scope="scope">
					<div>{{scope.row.department.parentName}} / {{scope.row.department.departmentName}}</div>
				</template>
			</el-table-column>
			
     
	   <el-table-column sortable prop="createDate" label="创建时间" width="240">
	    <template slot-scope="scope">
	      <div>{{scope.row.createDate|timestampToTime}}</div>
	    </template>
	  </el-table-column>
      <el-table-column sortable prop="updateDate" label="修改时间" width="240">
        <template slot-scope="scope">
          <div>{{scope.row.updateDate|timestampToTime}}</div>
        </template>
      </el-table-column>
     <!-- <el-table-column sortable prop="editUser" label="修改人" width="300">
      </el-table-column> -->
      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
         <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>-->
         
					
					 <prems-button  perms="sys:role:delete" label="删除"  size="mini" type="danger"  @click="deleteUser(scope.$index, scope.row)" />
					 <el-button size="mini" type="success" @click="menuAccess(scope.$index, scope.row)">菜单权限</el-button> 
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")' :close-on-click-modal="false">
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
      
        <el-form-item label="角色名称" prop="role">
          <el-input v-model="editForm.role" auto-complete="off" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" prop="description">
          <el-input v-model="editForm.description" auto-complete="off" placeholder="请输入角色代码"></el-input>
        </el-form-item>
				<el-form-item label="选择部门" prop="departmentStr">
				 <el-cascader
				 	v-model="getDeptData"
				 	ref="depsCascader"
				 	:options="deptData"
				 	:props="{ expandTrigger: 'click',children:'deps',label:'departmentName',checkStrictly: true,value:'id'}"
				 	@change="handleChange">
				 </el-cascader>
				</el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button> -->
				<prems-button  perms="sys:role:update" label="保存"  size="small" type="primary"  @click="submitForm('editForm')" />
      </div>
    </el-dialog>
    <!-- 菜单权限 -->
    <el-dialog :title="disTitle" :visible.sync="menuAccessshow" width="30%" @click='closeDialog("perm")' :close-on-click-modal="false">
			
      <el-tree ref="tree" 
				:data="menuTreeData" 
				:props="RoleRightProps" 
				:default-checked-keys="checkmenu" 
				:check-strictly="true"
				node-key="id" 
				
				show-checkbox
			>
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("perm")'>取消</el-button>
        <!-- <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">保存</el-button> -->
				<prems-button :loading="loading"  perms="sys:role:menu" label="保存"  size="small" type="primary"  @click="menuPermSave" />
      </div>
    </el-dialog>
		
		
  </div>
</template>

<script>
import {
  roleList,
  roleSave,
  roleDelete,
  rolePwd,
  roleUpdate,
  RoleRightTree,
  RoleRightSave,
	userList,
	ModuleList,
	departmentList
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import PremsButton from "@/views/permission/PreButtom";

export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      menuAccessshow: false, //控制数据权限显示与隐藏
      title: '添加',
			disTitle:'',
      editForm: {
        role: '',
        description: '',
				departmentStr:0
      },
			getDeptData:[],
			deptData:[],
			 // 请求数据参数
			// userInline: {
			//  currentPage: 1,
			//  pageSize: 10,
			//  uid: 0,
			//  username: '',
			//  name:'',
			//  password: '',
			//  phone: '',
			//  roomNum:'',
			//  
			//  roleListStr: JSON.stringify([])
			// 	
			// },
			userListForm:false,
      // rules 表单验证
      rules: {
       
        role: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入角色描述', trigger: 'blur' }
        ],
				departmentStr:[
					{ required: true, message: '请选择部门', trigger: 'blur' }
				]
      },
      formData: {
        currentPage: 1,
        pageSize: 10,
        role: '',
        description: '',
				depId:""
        
      },
      currRoleId:0,
	     delIds:'',
      
      userparm: [], //搜索权限
      listData: [], //用户数据
			userData: [],
     
      menuTreeData: [],
      RoleRightProps: {
        label: "name",
        children: "menus"
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
		PremsButton
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.getdata(this.formData)
		this.getmenu()
		this.getdept()
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
		
		getDepId:function(val){
			this.formData.depId = val[0]
		},
		
		
    // 获取角色列表
    getdata(parameter) {
     
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
			 this.loading = true
      roleList(parameter).then(res => {
        
        this.loading = false
		 
		 
				if(res.status == 1){
					this.listData = res.data.data
					this.pageparm.currentPage = this.formData.currentPage
					this.pageparm.pageSize = this.formData.pageSize
					this.pageparm.total = res.data.totalCount
				}
          
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取角色列表失败，请稍后再试！')
        })
    },
		
		//获取所有的部门信息
		getdept(){
			
			departmentList().then(res => {
				if(res.status == 1){
					this.deptData = res.data
				}else{
					this.$message.error(res.msg)
				}
			})
			.catch(err => {
			  this.loading = false
			  this.$message.error('获取部门信息失败，请稍后再试！')
			})
		},
		
		handleChange(e){
			let id = e[e.length-1]
			console.log(this.getDeptData)
			this.editForm.departmentStr = id
		},
		
		
		
    // 分页插件事件
    callFather(parm) {
      this.formData.currentPage = parm.currentPage
      this.formData.pageSize = parm.pageSize
      this.getdata(this.formData)
    },
    // 搜索事件
    search() {
      this.getdata(this.formData)
    },
		
		
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
			this.$nextTick(() => {
				this.$refs.editForm.clearValidate();
			})
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
      
				this.editForm.role = row.role
				this.editForm.description = row.description
				this.editForm.departmentStr = row.department.id
				this.currRoleId  = row.id
				let arrStr = row.department.parentId+','+row.department.id
			
				this.getDeptData = [row.department.id]
			
      } else {
        this.title = '添加'
        this.editForm.role = ''
        this.editForm.description = ''
				this.getDeptData =[]
       
		
      }
    },
	
	
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
	      if(this.title == '添加'){
			  this.addRole()
		  }else{
			  this.upDateRole()
		  }
          
        } else {
          return false
        }
      })
    },
	
	
	//添加角色
	addRole(){
		roleSave(this.editForm)
		  .then(res => {
		    this.editFormVisible = false
		    this.loading = false
		    if (res.status == 1) {
		      this.getdata(this.formData)
		      this.$message({
		        type: 'success',
		        message: '角色保存成功！'
		      })
		    } else {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    }
		  })
		  .catch(err => {
		    this.editFormVisible = false
		    this.loading = false
		    this.$message.error('角色保存失败，请稍后再试！')
		  })
	},
	
	//修改角色
	upDateRole(){
		
		roleUpdate({...this.editForm,id:this.currRoleId})
		  .then(res => {
		    this.editFormVisible = false
		    this.loading = false
		    if (res.status == 1) {
		      this.getdata(this.formData)
		      this.$message({
		        type: 'success',
		        message: '角色保存成功！'
		      })
		    } else {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    }
		  })
		  .catch(err => {
		    this.editFormVisible = false
		    this.loading = false
		    this.$message.error('角色保存失败，请稍后再试！')
		  })
	},
	handleSelectionChange(val){
		let arr = []
		val.forEach( item => {
			arr.push(item.id)
		})
		this.delIds = arr.join('-')
		
	},
	
    // 删除角色
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?角色信息删除后，与它绑定的用户将会重新分配', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
		
		   
		  let ids = row?row.id:this.delIds
		 
          roleDelete({id:ids})
            .then(res => {
              if (res.status == 1) {
                this.$message({
                  type: 'success',
                  message: '角色已删除！'
                })
                this.getdata(this.formData)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('角色删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    

		
		// 数据权限
    menuAccess: function(index, row) {
			
			// console.log(row)
			
      this.menuAccessshow = true
			this.saveroleId = row.id
			this.disTitle = '给角色 '+row.role+' 分配权限'
		  
			let param = {
				id:this.saveroleId
			}
      RoleRightTree(param)
        .then(res => {
          if (res.status == 1) {
            this.checkmenu = res.data
						this.$refs.tree.setCheckedKeys(this.checkmenu);
          } else {
            this.$message({
              type: 'info',
              message: res.data.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取权限失败，请稍后再试！')
        })
    },
		
		
		getCheckedNodes() {
        var rad=''
        var ridsa = this.$refs.tree.getCheckedKeys().join(',')// 获取当前的选中的数据[数组] -id, 把数组转换成字符串
        var ridsb = this.$refs.tree.getCheckedNodes()// 获取当前的选中的数据{对象}
        ridsb.forEach(ids=>{//获取选中的所有的父级id
          rad+=','+ids.parentId
        })
				
        rad=rad.substr(1) // 删除字符串前面的','
				
        var rids=rad+','+ridsa
        var arr=rids.split(',')//  把字符串转换成数组
				
        arr=[...new Set(arr)].filter( item => item!=0  ); // 数组去重
				
        rids=arr.join('-')// 把数组转换成字符串
				return rids
     },

		   // 菜单权限-保存
		menuPermSave() {
		  let parm = {
		    id: this.saveroleId,
		    str: ''
		  }
			
			this.loading = true
			parm.str = this.getCheckedNodes();
		
		
		  RoleRightSave(parm)
		    .then(res => {
					this.loading = false
		      if (res.status == 1) {
		        this.$message({
		          type: 'success',
		          message: '权限保存成功'
		        })
		        this.menuAccessshow = false
		       
		      } else {
		        this.$message({
		          type: 'info',
		          message: res.msg
		        })
		      }
		    })
		    .catch(err => {
		      this.loading = false
		      this.$message.error('权限保存失败，请稍后再试！')
		    })
		},
		
		
		
		
		
		
			//获取所有菜单列表
		 getmenu() {
			ModuleList().then( res => {
				this.loading = false;
			
				if(res.errCode){
					this.$message.error('数据获取失败，请稍后再试')
					return
				}
				this.menuTreeData = res.data
			
				
			})	
		},
		
  
 
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
			
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.menuAccessshow = false
      }
			
    }
  }
}
</script>

<style scoped>

.userRole {
  width: 100%;
}
</style>

 


// WEBPACK FOOTER //
// src/views/system/Role.vue